import {
  accountingAutomatedReports,
  commonFilters,
  extraARFilters,
  reportUrls,
} from '../utils/urlResolver';
import axios from '.';

export const getReportData = (reportType, params) => {
  return axios({
    method: 'get',
    url: reportUrls[reportType]?.url,
    params,
  });
};
export const getPayOffReportAmount = (reportType, params) => {
  return axios({
    method: 'get',
    url: reportUrls[reportType]?.amountUrl,
    params,
  });
};
export const getTotalCount = (reportType, params) => {
  return axios({
    method: 'get',
    url: reportUrls[reportType]?.totalCountUrl,
    params,
  });
};
export const getAutomatedReportsData = (reportType, params) => {
  return axios({
    method: 'get',
    url: accountingAutomatedReports[reportType]?.url,
    params,
  });
};

export const fetchCommonFilters = (params) => {
  return axios({
    method: 'get',
    url: commonFilters.url,
    params,
  });
};

export const fetchDashboardCommonFilters = (params) => {
  return axios({
    method: 'get',
    url: commonFilters.dashboardUrl,
    params,
  });
};

export const DownloadReportData = (reportType, params) => {
  return axios({
    method: 'get',
    url: reportUrls[reportType]?.downloadUrl,
    responseType: 'blob',
    params,
  });
};

export const EmailDownloadReportData = (reportType, data) => {
  return axios({
    method: 'post',
    url: reportUrls[reportType]?.downloadUrl,
    data,
  });
};

export const EmailReportData = (reportType, data) => {
  return axios({
    method: 'post',
    url: reportUrls[reportType]?.emailUrl,
    data,
  });
};

export const DownloadReportCSVData = (reportType, params) => {
  return axios({
    method: 'get',
    url: reportUrls[reportType]?.downloadCSVUrl,
    responseType: 'blob',
    params,
  });
};

export const getARDetailFilters = (params) => {
  return axios({
    method: 'get',
    url: extraARFilters.url,
    params,
  });
};
